/***
 * @Author: hippo
 * @Date: 2024-01-15 10:54:37
 * @LastEditors: hippo
 * @LastEditTime: 2024-12-25 15:38:29
 * @Description: 
 * @
 */
import api from '@/apis'

export const fetchList = params => api.get(`/referrals`, { params })
export const setActiveState = (id, isActive) => api.put(`/referrals/${id}/set_active`, { isActive })

export const fetchRetailList = params => api.get(`/referrals/retail`, { params })
